import React, { useState, useEffect } from "react";
import { IGlobalPoprop } from "../../interfaces/global-interface";
import { ISalidaInventario, SalidaInventarioError } from "../../interfaces/entrada-salida-interface";
import { getServiceData, saveServiceData } from "../../store/global-services";
import ButtonGST from "../../atoms/Controls/ButtonGTS";
import { StyledTableRow, StyledTableCell } from "../../atoms/tables/TableStyles";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Table, TableBody, TextField, TableContainer, TableHead, TableRow, FormControl, FormHelperText, InputLabel, Select, MenuItem, SelectChangeEvent, Stack, Pagination } from "@mui/material";
import { UrlSiteBase, formatDateFromStr } from '../../Global';
import { SwitchLabelGTS } from "../../atoms/Controls/SwitchGTS";
import { DialogGTS } from "../../molecules/DialogGTS";
let { UrlBase } = UrlSiteBase();
const SalidaInventario = (globalProp?: IGlobalPoprop) => {
    const { idDistribuidora } = useParams();
    const { idSalida } = useParams();
    const [ idSalidaState, setIdSalidaState ] = useState<number>(0);
    const [idDistEditar, setIdDisEditar] = useState<string>(idDistribuidora || '0');
    const [productos, setProductos] = useState<any>([]);
    const [idTipoSalida, setIdTipoSalida] = useState<string>('0');
    const [salida, setSalida] = useState<ISalidaInventario>();
    const [tiposSalida, setTiposSalida] = useState<any>([]);
    const [observaciones, setObservaciones] = useState<string>('');
    const [motivoCancelacion, setMotivoCancelacion] = useState<string>('');
    const [isActive, setIsActive] = useState<boolean>(idSalida ? (salida?.estatus === 1 ? true : false) : true);
    const [error, setError] = useState(SalidaInventarioError);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [prodCache, setProdCache] = useState<any>([]);
    const navigate = useNavigate();
    
    const getSalidaInventario = () => {
        if (idSalida !== undefined)
            setIdSalidaState(parseInt(idSalida, 10));
        if (tiposSalida.length === 0) 
            return;
        getServiceData({ 
            nombre: 'salida-inventario', 
            id: idSalidaState.toString(),
            parametros: idDistribuidora === undefined ? {} : { idDistribuidora: idDistribuidora }
        }).then(data => {
            if (data.success) {
                setIdDisEditar(data.salida.idDistribuidora);
                setIdTipoSalida(data.salida.idTipoSalida);
                setObservaciones(data.salida.observaciones);
                setMotivoCancelacion(data.salida.motivoCancelacion || '');
                setIsActive(data.salida.estatus === 1);
                data.salida.productos.forEach((prod: any) => {
                    prod.nombre = idSalidaState === 0 ? prod.nombre : prod.producto;
                    prod.errorCantidadContenedor = '';
                    prod.cantidadContenedor = prod.cantidadContenedor || 0;
                    prod.cantidadSuelta = prod.cantidadSuelta || 0;
                    prod.cantidadExistente = prod.cantidadExistente || 0;
                    setCantidadEmpaqueTotal(prod);
                });
                setProductos(data.salida.productos);
                setSalida(data.salida);
                setTotalPages(data.pagination.last_page);
            }
        });
    }
    const getTiposSalida = () => {
        getServiceData({ nombre: 'tipos-salida' }).then(data => {
            if (data.success) {
                setTiposSalida(data.tiposSalidas);
            }
        });
    };
    useEffect(() => {
        getTiposSalida();
    }, []);
    useEffect(() => {
        getSalidaInventario();
    }, [tiposSalida, page]);

    // Sumar contenedor
    const setProductAddInvContenedor = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>,row: any) => {
        event.stopPropagation();
        let cantidadContenedor = (row.cantidadContenedor || 0) + 1;
        if ((cantidadContenedor * row.capacidadContenedor) > row.cantidadExistente)
            return; 
        row.cantidadContenedor = cantidadContenedor;
        setCantidadEmpaqueTotal(row);
        setProductos([...productos]);
    };

    // Restar contenedor
    const setProductRestInvContenedor = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        event.stopPropagation();
        if (row.cantidadContenedor && row.cantidadContenedor > 0) {
            row.cantidadContenedor = row.cantidadContenedor - 1;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const setCantidadEmpaqueTotal = (row: any) => {
        row.cantidadEmpaqueTotal = (row.cantidadContenedor || 0) * row.capacidadContenedor + (row.cantidadSuelta || 0);
        setProdCache({ ...prodCache, [row.id]: row });// Cache the product to avoid recalculating
    };
    // Sumar sueltos
    const setProductAddInvSuelto = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        event.stopPropagation();
        let cantidadSuelta = (row.cantidadSuelta || 0) + 1;
        let cantidadEmpaqueTotal = row.cantidadEmpaqueTotal + 1;
        if (cantidadEmpaqueTotal > row.cantidadExistente) 
            return;
        row.cantidadSuelta = cantidadSuelta;
        setCantidadEmpaqueTotal(row);
        setProductos([...productos]);
    };

    // Restar sueltos
    const setProductRestInvSuelto = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>, row: any) => {
        event.stopPropagation();
        if (row.cantidadSuelta && row.cantidadSuelta > 0) {
            row.cantidadSuelta = row.cantidadSuelta - 1;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const getProdCache = (id: number, row: any) => {
        return prodCache[id] || row;
    };
    const handleProductInvContenedor = (value: string, row: any) => {
        const cantidad = parseInt((value || "0"), 10);
        if (!isNaN(cantidad)) {
            if ((cantidad * row.capacidadContenedor) > row.cantidadExistente)
               return;
            row.cantidadContenedor = cantidad;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const handleProductInvSuelto = (value: string, row: any) => {
        const cantidad = parseInt((value || "0"), 10);
        if (!isNaN(cantidad)) {
            let cantidadEmpaqueTotal = row.cantidadEmpaqueTotal - row.cantidadSuelta + cantidad;
            if (cantidadEmpaqueTotal > row.cantidadExistente)
                return;
            row.cantidadSuelta = cantidad;
            setCantidadEmpaqueTotal(row);
            setProductos([...productos]);
        }
    };
    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const { name, value } = event.target;
        setIdTipoSalida(value);
        setError(error => ({ ...error, [name]: '' })); // Reset error for idTipoSalida
    };
    const handleInputTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setObservaciones(value);
        setError(error => ({ ...error, [id]: '' })); // Reset error for observaciones
    }
    const handleInputTextChangeCancela = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { id, value } = event.target;
        setMotivoCancelacion(value);
        setError(error => ({ ...error, [id]: '' })); // Reset error for motivoCancelacion
    };
    const handleCheckbox = () => {
        setIsActive(!isActive);
        if (isActive){
            if (globalProp && globalProp.snackHandleOpen) {
                globalProp.snackHandleOpen({ open: true, message: 'Si cancelas esta salida, los productos se reingresaran al inventario.', color: 'orange' });
            }
        }
    }
    const handlePaginationChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPage(value);
    };
    const guardarSalidaInv = () => {
        let numProdSalida = 0;
        let prodsToSave = Object.values(prodCache);
        prodsToSave.forEach((prod: any) => {
            if (prod.cantidadContenedor > 0 || prod.cantidadSuelta > 0) {
                numProdSalida++;
            }
        });
        if (numProdSalida === 0) {
            if (globalProp && globalProp.snackHandleOpen)
                globalProp.snackHandleOpen({ open: true, message: 'Debe agregar al menos un producto a la salida de inventario.', color: 'red' });
            return;
        }
        saveServiceData({ reqMethod: 'PUT', nombre: 'salida-inventario', datos : 
            { 
                id: idSalidaState ?? 0,
                idDistribuidora: idSalidaState === 0 ? idDistribuidora : salida?.idDistribuidora,
                idTipoSalida: idTipoSalida,
                observaciones: observaciones,
                estatus: isActive ? 1 : 2,
                motivoCancelacion: isActive ? null : motivoCancelacion,
                'productos': prodsToSave.filter((prod: any) => prod.cantidadContenedor > 0 || prod.cantidadSuelta > 0)
            }
        }).then((data) => {
            if (data.success) {
                navigate(UrlBase + 'Salida-Inventario');
                if (globalProp && globalProp.snackHandleOpen)
                    globalProp.snackHandleOpen({ open: true, message: data.message });
            }
            else {
                setError(SalidaInventarioError);
                for (const [key, value] of Object.entries(data.message)) {
                    setError(error => ({...error, [key]: value}));
                }
            }
        });
    };
    const getSafeValue = (field: any) => {
        return field === undefined || field === null ? '' : field;
    };
    return (
        <>
            <Box className="form-gst maximum" component="form" noValidate autoComplete="off">
                <div className="panel-inputs">
                    <div className="d-inline-flex p-2">
                        <div>
                            <div className="label">Distribuidora: {salida?.distribuidora}</div>
                            <div className="label">Usuario: {salida?.usuario}</div>
                        </div>
                    </div>
                    {idSalidaState > 0 ? 
                        <div className="d-inline-flex p-2">
                            <div>
                                <div className="label">Fecha de salida al inventario: { formatDateFromStr(salida?.fecha + "")}</div>
                                <FormControl className="check-control" error={error.estatus !== ''}>
                                    <SwitchLabelGTS label={isActive ? "Activo" : "Cancelado"} id="estatus" checked={isActive} onChange={handleCheckbox} />
                                </FormControl>
                            </div>
                        </div>
                        : <></>
                    }
                    <FormControl className="select-control">
                        <InputLabel id="perfil-label">Tipo de salida</InputLabel>
                        <Select labelId="tipo-salida" id="tipo-salida" name="idTipoSalida" value={idTipoSalida} label="Tipo de salida" onChange={handleSelectChange}>
                            <MenuItem value={0}>Seleccione un tipo de salida</MenuItem>
                            {tiposSalida?.map((tipoSalida: any) => (
                                <MenuItem key={tipoSalida.id} value={tipoSalida.id}>{tipoSalida.nombre}</MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{error.idTipoSalida}</FormHelperText>
                    </FormControl>
                    <TextField id="observaciones" className="medium-textarea" onChange={handleInputTextChange} multiline rows={2}
                            value={getSafeValue(observaciones)} label="Observaciones" color="secondary" error={error.observaciones !== ''}  helperText={error.observaciones} />
                    {idSalidaState > 0 && !isActive ? 
                        <>
                            <div className="d-inline-flex">
                                <div>
                                    <TextField id="motivoCancelacion" className="medium-textarea" onChange={handleInputTextChangeCancela} multiline rows={2}
                                        value={getSafeValue(motivoCancelacion)} label="Motivo de Cancelación" color="secondary" error={error.motivoCancelacion !== ''}  helperText={error.motivoCancelacion} />
                                </div>
                            </div>
                            {salida?.fechaCancela ? 
                                <div className="d-inline-flex">
                                    <div>
                                        <div className="label">Fecha de cancelación: { formatDateFromStr(salida?.fechaCancela + "")}</div>
                                    </div>
                                </div> 
                                : <></>}
                        </>
                    : <></>}
                </div>
            </Box>
            <TableContainer>
                <Table className="table-gts product-table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell>ID</StyledTableCell>
                            <StyledTableCell>Producto</StyledTableCell>
                            <StyledTableCell align="center">Cantidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Capacidad Contenedor</StyledTableCell>
                            <StyledTableCell align="center">Empaques Sueltos</StyledTableCell>
                            {idSalida === '0' ? <StyledTableCell align="center">Cantidad Existente</StyledTableCell> : <></>}
                            <StyledTableCell align="center">Empaques Totales</StyledTableCell>
                            {idSalida === '0' ? <StyledTableCell align="center">Cantidad restante</StyledTableCell> : <></>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {productos?.map((row: any) => (
                            <StyledTableRow key={row.id}>
                                <StyledTableCell>{row.id}</StyledTableCell>
                                <StyledTableCell>{row.nombre}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idSalida === undefined ? (
                                        <div className="controls">
                                            <button className="add-product" onClick={(event) => setProductAddInvContenedor(event, row)}>+</button>
                                            <TextField className="input-cantidad" value={getProdCache(row.id, row)?.cantidadContenedor} error={row?.errorCantidadContenedor !== ''}  helperText={row?.errorCantidadContenedor} onChange={(event) => handleProductInvContenedor(event.target.value, row)} />
                                            <button className="minus-product" onClick={(event) => setProductRestInvContenedor(event, row)} >-</button>
                                        </div>
                                    ) : (
                                        <div>{row?.cantidadContenedor}</div>
                                    )}
                                </StyledTableCell>
                                <StyledTableCell align="center">{row?.capacidadContenedor}</StyledTableCell>
                                <StyledTableCell align="center">
                                    {idSalida === undefined ? (
                                        <div className="controls">
                                            <button className="add-product" onClick={(event) => setProductAddInvSuelto(event, row)}>+</button>
                                            <TextField className="input-cantidad" value={getProdCache(row.id, row)?.cantidadSuelta} error={row?.errorCantidadSuelta !== ''}  helperText={row?.errorCantidadSuelta} onChange={(event) => handleProductInvSuelto(event.target.value, row)} />
                                            <button className="minus-product" onClick={(event) => setProductRestInvSuelto(event, row)} >-</button>
                                        </div>
                                    ) : (
                                        <div>{row?.cantidadSuelta}</div>
                                    )}
                                </StyledTableCell>
                                {idSalida === '0' ? <StyledTableCell align="center">{row?.cantidadExistente}</StyledTableCell> : <></>}
                                <StyledTableCell align="center">{getProdCache(row.id, row)?.cantidadEmpaqueTotal}</StyledTableCell>
                                {idSalida === '0' ? <StyledTableCell align="center">{row?.cantidadExistente - getProdCache(row.id, row)?.cantidadEmpaqueTotal}</StyledTableCell> : <></>}
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            { totalPages > 1 ?
                <Stack spacing={2}>
                    <Pagination count={totalPages} page={page} onChange={handlePaginationChange} />
                </Stack> 
                : <></>
            }
            <div className="panel-actions align-right">
                <ButtonGST onClick={() => navigate(UrlBase + 'Salida-Inventario')}> { idSalidaState > 0 ? 'Cancelar Edición' : 'Cancelar Salida' }</ButtonGST>
                {salida?.estatus === 1 && <ButtonGST onClick={guardarSalidaInv}>Guardar</ButtonGST>}
            </div>
        </>
    );
};
export default SalidaInventario;